import { createContext, useContext } from 'react';
const TreeSelectContext = createContext(null);

export function useTreeSelectContext() {
  const ctx = useContext(TreeSelectContext);
  if (!ctx) {
    throw new Error('useTreeSelectContext must be used within TreeSelect');
  }
  return ctx;
}

export default TreeSelectContext;
